import { render } from "./LoginBlock.vue?vue&type=template&id=7879ac26&scoped=true"
import script from "./LoginBlock.vue?vue&type=script&lang=js"
export * from "./LoginBlock.vue?vue&type=script&lang=js"

import "./LoginBlock.vue?vue&type=style&index=0&id=7879ac26&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7879ac26"]])

export default __exports__